import { render, staticRenderFns } from "./newOrden.vue?vue&type=template&id=01459762"
import script from "./newOrden.vue?vue&type=script&lang=js"
export * from "./newOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports